module.exports = __webpack_public_path__ + "static/img/email-icon.022df475.png";